import { render, staticRenderFns } from "./selectMapPos.vue?vue&type=template&id=1ddcb7b8&scoped=true"
import script from "./selectMapPos.vue?vue&type=script&lang=js"
export * from "./selectMapPos.vue?vue&type=script&lang=js"
import style0 from "./selectMapPos.vue?vue&type=style&index=0&id=1ddcb7b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddcb7b8",
  null
  
)

export default component.exports